function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext, useState } from 'react';
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import DomainSubNavigator2 from "nood-comp/src/comp/ui/nav/DomainSubNavigator2";
import SignupRequests from "src/routes/orgs/signup-requests/SignupRequests";
import SignupRequestView from "src/routes/orgs/signup-requests/SignupRequestView";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import { NoodleModalContext } from "nood-comp/src/comp/modal/NoodleModalProvider";
import { NoodleModalTemplates } from "nood-comp/src/comp/modal/noodle-modal/NoodleModalTemplates";
import { useDocumentTitle } from "usehooks-ts";
import { msg } from "src/app/msg";
export default function SignupRequest(props) {
  useDocumentTitle(msg.title('Signup Request'));
  var modalCtx = useContext(NoodleModalContext);
  var id = useURLParam('id');
  var __del = function __del() {
    modalCtx.__confirm("Are you sure you want to delete this signup request?", {
      title: "Delete Signup Request",
      primary: _objectSpread(_objectSpread({}, NoodleModalTemplates.button["delete"]), {}, {
        __do: function __do(modalIdx, ops) {
          ops.setIsProcessing(true);
        }
      }),
      secondary: _objectSpread({}, NoodleModalTemplates.button.no)
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: "Signup Requests"
  }), /*#__PURE__*/React.createElement(DomainSubNavigator2, {
    queryFilter: "do",
    parentPath: "/orgs?pg=invite-requests",
    defaultHighlight: 'list',
    menuItems: [{
      id: 'list',
      label: 'Requests',
      icon: "menu",
      content: /*#__PURE__*/React.createElement(SignupRequests, null),
      queryString: {
        id: undefined
      }
    }, {
      id: "view",
      label: "View",
      icon: "eye",
      content: /*#__PURE__*/React.createElement(SignupRequestView, null),
      show: id
    }, {
      id: "del",
      label: "Delete",
      icon: "trash-2",
      __click: function __click(evt) {
        __del();
      },
      show: id
    }]
  }));
}
SignupRequest.propTypes = {
  // proptypes
};
SignupRequest.defaultProps = {
  // default propTypes
};